import getCollection from './getCollection'
import getDataById from 'actions/base/getDataById'

const getSlotTimetable = async (id) => getDataById(id, getCollection)

export default getSlotTimetable
